import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SparkPopover } from '../ui/spark';

const noop = () => {};
export default class Popover extends Component {
    static propTypes = {
        /** SparkPopover properties */
        anchorX: PropTypes.string,
        /** SparkPopover properties */
        anchorY: PropTypes.string,
        /** React Element will show tag to toggle popover. */
        toggleEl: PropTypes.element.isRequired,
        /** React Elements to be displayed within the popover */
        children: PropTypes.element.isRequired,
        /** callback to be invoked when popover opens */
        onOpen: PropTypes.func,
        /** callback to be invoked when popover close */
        onClose: PropTypes.func
    };

    static defaultProps: {
        onOpen: noop,
        onClose: noop
    };

    static displayName = 'Popover';

    constructor(props) {
        super(props);
        this._container = null;
        this._closePopover = this._closePopover.bind(this);
    }

    _closePopover() {
        this._sparkInstance.close();
    }

    render() {
        return (
            <div ref={el => (this._container = el)} className="spark-popover">
                {this.props.toggleEl}
                <div className="spark-popover__content" role="tooltip">
                    {this.props.children}
                    <span className="spark-popover__caret"></span>
                </div>
            </div>
        );
    }

    componentDidMount() {
        const { anchorX, anchorY, onOpen, onClose, toggleEl } = this.props;
        this._sparkInstance = new SparkPopover(this._container, { anchorX, anchorY, onOpen, onClose, toggleEl });
    }

    componentWillUnmount() {
        this._sparkInstance = undefined;
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkPopover.js